export const PaginatedButtonClassNames =
  'w-11 h-11 mx-2 my-4 p-2 bg-neutral100 text-center'
export const PaginatedDisabledButtonClassNames =
  'hover:cursor-not-allowed opacity-30'
export const PaginationContainerClassNames =
  'w-full bg-neutral50 flex flex-row items-center justify-center overflow-x-scroll'
